module.exports = __webpack_public_path__ + "static/media/Senior.6babf177.jpg";